export default __webpack_public_path__ + "static/media/agile-polly-logo.e96ad57b.svg";